import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "2re0a6ab",
    dataset: "production",
    apiVersion: 1,
    useCdn: "false",
});
